import { AuthContext } from '../../providers/AuthProvider';
import { Navigate, useLocation } from 'react-router-dom';
import { FC, ReactNode, useContext } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import { Box, CssBaseline } from '@mui/material';
import CurrentViewProvider from '../../providers/CurrentViewProvider';
import Main from '../Main/Main';

interface Props {
  children?: ReactNode;
}

const ProtectedRoute: FC<Props> = ({ children }) => {
  const { authenticated } = useContext(AuthContext);
  const location = useLocation();

  if (authenticated) {
    return (
      <Box sx={{ height: '100%' }}>
        <CssBaseline />
        <CurrentViewProvider>
          <Header />
          <Sidebar />
          <Main>{children}</Main>
        </CurrentViewProvider>
      </Box>
    );
  } else {
    return (
      <Navigate
        replace
        to="/login"
        state={{ path: location.pathname }}
      />
    );
  }
};

export default ProtectedRoute;
